/* eslint-disable @typescript-eslint/naming-convention */
import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {LocalUser, LocalUserAction, LocalUserState} from '@app/state/local-user.state';
import {AccessType} from '@app/modules/shared/data/constants';
import {UtilService} from '@app/modules/shared/services/util.service';
import {Store} from '@ngxs/store';
import {Message, MessageType} from '@app/models/message';
import {ChatService} from '@app/modules/chat/services/chat.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';


@Component({
  selector: 'app-local-user-list-item',
  templateUrl: './local-user-list-item.component.html'
})
export class LocalUserListItemComponent implements OnInit {

  public localUser: LocalUser;
  public classroom: ClassroomStateModel;
  public isMessageBoxCollapsed = false;
  // public  remoteUser: RemoteParticipantInfo;
  public MessageTypes = MessageType;
  public AccessType = AccessType;
  public UtilService = UtilService;
  @ViewChild('inputValue')
  public inputMassage;
  @ViewChildren('chatInput')
  public chatInput: QueryList<ElementRef>;

  public messages: {
    own: Message[];
    ownLimited: Message[];
  } = {
    own: [],
    ownLimited: []
  };

  constructor(
    public utilService: UtilService,
    private store: Store,
    private chatService: ChatService,
  ) {
    this.registerEventListeners();
  }

  public ngOnInit(): void {}

  public registerEventListeners(): void {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
    this.store.select(ClassroomState).subscribe(classroom => {
      this.classroom = classroom;
      this.messages.own = this.getOwnMessages();
      this.messages.ownLimited = this.getOwnLimitedMessages();
    });
  }

  public selfMessage(message: any) {
    if (message.length > 0) {
      const messageModel = new Message();
      messageModel.senderId = this.localUser.id;
      messageModel.targetId = this.localUser.id;
      messageModel.text = message;
      messageModel.messageType = MessageType.TO_STAFF;
      this.chatService.sendMessage(messageModel).subscribe();
      this.chatService.sendClassWideMessage(messageModel).subscribe();
      this.inputMassage.nativeElement.value = '';
    }
  }

  public clearSupportIndividualChat(): void {
    console.log('delete');
  }

  public toggleShowMessages(): void {
    this.isMessageBoxCollapsed = !this.isMessageBoxCollapsed;
  }

  public generateLimitedMessagesArray(messages: Message []): { array: Message []; doesMessageLengthExceededLimit: boolean } {
    let totalMessagesLength = 0;
    const limitedArray: Message[] = [];
    const limit = 25;
    for (let i = messages.length - 1; i >= 0; i--) {
      if (totalMessagesLength + messages[i].text.length < limit) {
        limitedArray.push(messages[i]);
        totalMessagesLength += messages[i].text.length + 2;
      } else {
        const messageText: string = messages[i].text.substring(messages[i].text.length - (limit - totalMessagesLength));
        if (messageText !== '') {
          messages[i].text = messageText;
          limitedArray.push(messages[i]);
        }
        return {array: limitedArray, doesMessageLengthExceededLimit: true};
      }
    }
    return {array: limitedArray, doesMessageLengthExceededLimit: false};
  }

  public getOwnMessages(): Message[] {
    const ownMessages: Message[] = [];
    this.classroom.messages.forEach((message: Message) => {
      if (message.targetId === this.localUser.id) {
        ownMessages.push(message);
      }
    });
    return ownMessages;
  }

  public getOwnLimitedMessages(): Message[] {
    let ownLimitedMessages: Message[] = [];
    this.classroom.messages.forEach((message: Message) => {
      if (message.targetId === this.localUser.id) {
        ownLimitedMessages.push(message);
        const messagesCopy: Message[] = JSON.parse(JSON.stringify(ownLimitedMessages));
        const limit = this.generateLimitedMessagesArray(messagesCopy);
        ownLimitedMessages = limit.array;
      }
    });
    return ownLimitedMessages;
  }

  public clearIndividualChat(): void {
    this.chatService.sendClearUserMessages(this.localUser.id).subscribe();
  }

  public manuallyHideUnansweredMessageIcon(): void {
    this.store.dispatch(new LocalUserAction.SetHasUnansweredMessage(false));

    const messageModel = new Message();
    messageModel.senderId = this.localUser.id;
    messageModel.targetId = this.localUser.id;
    messageModel.messageType = MessageType.SEEN;
    this.chatService.sendMessage(messageModel).subscribe();
    this.chatService.sendClassWideMessage(messageModel).subscribe();
  }
}
